{{ getMessage(data.payload, localizationService) }}
